export default "__VITE_ASSET__808a24e4__"